import {
  ArticleOutlineIcon,
  StarOutlineIcon,
  PlayOutlineIcon,
  ToolsOutlineIcon,
} from '@/components/icons';
import { BlogCategories } from '@/common/constants/blog';
import { CONTENT_CATEGORY } from '../../domains/home/constants';

export const icons = {
  [BlogCategories.ARTICLES]: ArticleOutlineIcon,
  [BlogCategories.VIDEOS]: PlayOutlineIcon,
  [BlogCategories.REAL_LIFE_STORIES]: StarOutlineIcon,
  [CONTENT_CATEGORY.Tools]: ToolsOutlineIcon,
  [CONTENT_CATEGORY.Insurance]: StarOutlineIcon,
};
